import router, {ROUTE_NAMES} from "@/router/index"
import {routerBeforeEchHook} from "@/services/auth/Auth.js";

const beforeEachGuard = ((to, from, next) => {

    console.log('beforeEachGuard', to.name, from.name)

    const toName = to.name

     routerBeforeEchHook(aloveddNames => {

        if (aloveddNames === '*') {
            next()
            return
        }

        // is array
        if (Array.isArray(aloveddNames)) {
            if (aloveddNames.includes(toName)) {
                next()
                return
            } else {
                next({name: ROUTE_NAMES.HOME_VIEW})
                return
            }
        } else {
            // return  next()
        }

    })


})

export default beforeEachGuard

